import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import LoginButton from './LoginButton';
import LogoutButton from './LogoutButton';
import LoadingContainer from '../loadingContainer/LoadingContainer';
import { useTranslation } from 'react-i18next';

const AuthenticationButton = (): JSX.Element => {
    const { isAuthenticated, isLoading } = useAuth0();
    const { t } = useTranslation();

    return (
        <LoadingContainer loading={isLoading} message={t('loading')}>
            {isAuthenticated ? <LogoutButton /> : <LoginButton />}
        </LoadingContainer>
    );
};

export default AuthenticationButton;
